import React from "react";
import { useAuth } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
// #192A81
// #52C44E
  return (
    <div className="bg-light min-vh-100 d-flex flex-column">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg" style={{ backgroundColor: '#192A81' }}>
  <div className="container">
    <Link to="/" className="navbar-brand fw-bold fs-1" style={{ color: '#FEFFFF' }}>
      SmartLend
    </Link>
    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link to="/" className="nav-link fs-5" style={{ color: '#FEFFFF' }}>
            Home
          </Link>
        </li>
        
        {!user && (
          <>
            <li className="nav-item">
              <Link to="/login" className="nav-link fs-5" style={{ color: '#FEFFFF' }}>
                Login
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/register" className="nav-link fs-5" style={{ color: '#FEFFFF' }}>
                Register
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/admin/login" className="nav-link fs-5" style={{ color: '#FEFFFF' }}>
                |
              </Link>
            </li>
          </>
        )}

        {user && (
          <>
            <li className="nav-item">
              <Link to="/loan-application" className="nav-link fs-5" style={{ color: '#FEFFFF' }}>
                Apply for Loan
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/dashboard" className="nav-link fs-5" style={{ color: '#FEFFFF' }}>
                Dashboard
              </Link>
            </li>
            <li className="nav-item ms-3">
              <span className="nav-link fs-5 d-flex align-items-center" style={{ color: '#FEFFFF' }}>
                <div
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    backgroundColor: '#52C44E',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '10px',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#FEFFFF',
                  }}
                >
                  {user.firstName?.charAt(0).toUpperCase()}
                </div>
                {user.firstName}
              </span>
            </li>
            <li className="nav-item">
              <button
                onClick={handleLogout}
                className="btn btn-sm fs-5 py-2 px-4"
                style={{
                  backgroundColor: '#467beeff',
                  color: '#FEFFFF',
                  border: 'none',
                }}
              >
                Logout
              </button>
            </li>
          </>
        )}
      </ul>
    </div>
  </div>
</nav>

<main className="container my-5 flex-grow-1 shadow" style={{ backgroundColor: '#eef3f5ff', borderRadius: '20px' }}>
  {children}
</main>
    </div>
  );
};

export default Layout;
